import { render, staticRenderFns } from "./SaleNoteDetail.vue?vue&type=template&id=4bf8ccc9&scoped=true&"
import script from "./SaleNoteDetail.vue?vue&type=script&lang=js&"
export * from "./SaleNoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./SaleNoteDetail.vue?vue&type=style&index=0&id=4bf8ccc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8ccc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf8ccc9')) {
      api.createRecord('4bf8ccc9', component.options)
    } else {
      api.reload('4bf8ccc9', component.options)
    }
    module.hot.accept("./SaleNoteDetail.vue?vue&type=template&id=4bf8ccc9&scoped=true&", function () {
      api.rerender('4bf8ccc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/SaleNoteDetail.vue"
export default component.exports